import api from './request';

// const WORKBENCH_API = '/sg/mtop/proretail-pc/api/workbench';

/**
 * 灰度为用户校验
 * @see src/components/topbar/api.md
 */
export function apiGrayCheckUserP(params?: {
  projectTag?: string;
  userEmail?: string;
  userMiId?: string;
}) {
  return api.post(
    `/sg/mtop/proretail-pc/api/workbench/grayCheckUserP`,
    [
      {
        projectTag: params?.projectTag ?? 'global-retail-pc',
        userEmail: params?.userEmail,
        userMiId: params?.userMiId
      }
    ],
    { region: 'sg' }
  );
}
